/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/st_geometrytype.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Returns the geometry type of the supplied geometry, as a string.
 * For example: `ST_Point`, `ST_LineString`, `ST_Polygon`, `ST_MultiPoint`, `ST_MultiLineString`, `ST_MultiPolygon`, or `ST_GeometryCollection`.
 *
 * @example
 * ROW wkt = [
 *     "POINT(1.0 2.0)",
 *     "LINESTRING (30 10, 10 30, 40 40)",
 *     "POLYGON ((30 10, 40 40, 20 40, 10 20, 30 10))"]
 * | MV_EXPAND wkt
 * | EVAL geometry = TO_GEOSHAPE(wkt),
 *        type = ST_GEOMETRYTYPE(geometry),
 *        points = ST_NPOINTS(geometry)
 * | KEEP type, points
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'st_geometrytype',
  signatures: [
    {
      params: [
        {
          name: 'geometry',
          type: 'cartesian_point',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
    {
      params: [
        {
          name: 'geometry',
          type: 'cartesian_shape',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
    {
      params: [
        {
          name: 'geometry',
          type: 'geo_point',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
    {
      params: [
        {
          name: 'geometry',
          type: 'geo_shape',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
  ],
  preview: true,
  snapshotOnly: false,
};

export default definition;
